export const getChevronSvg = () =>
	`<svg viewBox="0 0 21.4142 12.1213" height="100%" style="display:block" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.707107 0.707107L10.7071 10.7071L20.7071 0.707107" stroke="currentColor" stroke-width="2"/></svg>`;
